import { render, staticRenderFns } from "./case_order_detail.vue?vue&type=template&id=5fa241b5&scoped=true"
import script from "./case_order_detail.vue?vue&type=script&lang=js"
export * from "./case_order_detail.vue?vue&type=script&lang=js"
import style0 from "./case_order_detail.vue?vue&type=style&index=0&id=5fa241b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa241b5",
  null
  
)

export default component.exports